// AUTO-GENERATED FROM scripts/data/custom-made-insoles.csv.
// Run `node scripts/generate-custom-made-catalog.mjs` to regenerate.
// Do not edit by hand.
//
// Custom-made products are marketing-facing summary cards, NOT
// orderable SKUs. They render on /catalog with a "Find a clinic"
// CTA + delivery window instead of the standard enquiry flow.

export type CustomMadeFamily =
  | "Custom-Made Solutions";

export interface CustomMadeProduct {
  family: CustomMadeFamily;
  /** Marketing slug (also the URL on /catalog/[code]). */
  code: string;
  productName: string;
  description: string;
  /** Thumbnail / grid card image, relative to /photos/products/. */
  image: string;
  /** Multi-image set used by the dedicated /catalog/[code] product
   *  page. Renders in a crossfading carousel matching the /products
   *  page. Always at least one entry — falls back to [image] when
   *  the CSV doesn't supply explicit detail images. */
  detailImages: readonly string[];
  /** Display string for the delivery window, e.g. "5-12 working days". */
  deliveryDays: string;
  /** Comma-separated list of available materials/options. */
  materials: string;
}

export const CUSTOM_MADE_PRODUCTS: readonly CustomMadeProduct[] = [
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-SANDALS",
    productName: "Orthopaedic sandal",
    description: "Custom orthopaedic insoles built into a sandal you would actually want to wear. Vegan leather upper, custom EVA footbed shaped to the patient scan, and three buckle colourways (arena, caqui, mustard).",
    image: "sandals/sandal-buckle-arena.png",
    detailImages: [
      "sandals/sandals-1.jpg",
      "sandals/sandals-lifestyle.png",
      "sandals/sandals-swimming-pool.png",
      "sandals/sandals-beach.png",
      "sandals/sandals-posh.png",
      "sandals/sandals-walking-beach.png",
    ],
    deliveryDays: "10-14 working days",
    materials: "Vegan leather, custom EVA footbed, multiple buckle colours",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-PA12",
    productName: "PA12 (Polyamide 12) custom insole",
    description: "Lattice-structured Polyamide 12, manufactured on HP industrial printers using Multi Jet Fusion technology at sub-millimetre resolution. Variable density across the insole means we can soften high-pressure zones and stiffen support areas in a single print, no glued layers, no compromise.",
    image: "pa12-front-back.png",
    detailImages: [
      "pa12-front-back.png",
      "pa12-left.png",
    ],
    deliveryDays: "5 working days",
    materials: "PA12 Polyamide, HP Multi Jet Fusion, variable lattice",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-TPU",
    productName: "TPU (thermoplastic polyurethane) custom insole",
    description: "Flexible, springy thermoplastic polyurethane, manufactured on state-of-the-art industrial printers. The premium option for active lifestyles: energy returns through the gait cycle while contour-printed lattice supports the arch and cushions the heel.",
    image: "transparent/tpu.png",
    detailImages: [
      "transparent/tpu.png",
    ],
    deliveryDays: "5 working days",
    materials: "TPU 90A, multi-zone lattice, flexible shell",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-CARBON",
    productName: "Carbon fibre custom insole",
    description: "The lightest, stiffest custom insole we make. High-performance carbon shell with a thin EVA top layer, machined to your scan. Built for runners and athletes who need rigid arch support without weight.",
    image: "transparent/carbon/front-back.png",
    detailImages: [
      "transparent/carbon/front-back.png",
      "transparent/carbon/left.png",
      "transparent/carbon/right.png",
      "transparent/carbon/side.png",
    ],
    deliveryDays: "7-10 working days",
    materials: "Carbon fibre, EVA top cover, 1.6mm shell",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-PP",
    productName: "Polypropylene custom insole",
    description: "Durable thermoplastic shell, vacuum-formed to a positive cast and tuned to clinic prescriptions. The classic functional orthotic material: stable, predictable, and long-lasting under daily wear.",
    image: "transparent/polypropylene/front-back.png",
    detailImages: [
      "transparent/polypropylene/front-back.png",
      "transparent/polypropylene/left.png",
      "transparent/polypropylene/right.png",
      "transparent/polypropylene/side.png",
    ],
    deliveryDays: "7-10 working days",
    materials: "Polypropylene, 3mm shell, EVA cushion top cover",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-FG",
    productName: "Fibreglass custom insole",
    description: "The middle-ground between rigid carbon and soft EVA: semi-flexible fibreglass-reinforced composite. Holds an arch shape under load but allows controlled flex through the gait cycle. Our most-prescribed shell.",
    image: "transparent/fibre-glass/front-back.png",
    detailImages: [
      "transparent/fibre-glass/front-back.png",
      "transparent/fibre-glass/left.png",
      "transparent/fibre-glass/right.png",
      "transparent/fibre-glass/side.png",
    ],
    deliveryDays: "7-10 working days",
    materials: "Fibreglass composite, EVA top cover, 2mm shell",
  },
  {
    family: "Custom-Made Solutions",
    code: "CUSTOM-EVA",
    productName: "EVA custom insole",
    description: "Ultra-soft custom EVA shell, our most cushioned option. Multi-density EVA layered to absorb shock at heel-strike and progressively stiffen toward the forefoot. Best for diabetic care, plantar fasciitis, and high-impact activities.",
    image: "transparent/eva/front-back.png",
    detailImages: [
      "transparent/eva/front-back.png",
      "transparent/eva/left.png",
      "transparent/eva/right.png",
      "transparent/eva/side.png",
    ],
    deliveryDays: "7-10 working days",
    materials: "Multi-density EVA, 4mm shell, breathable top cover",
  },
];

/** Image base for custom-made products. They live in the marketing
 *  app's existing /photos/products/ folder rather than the
 *  /products/custom-made-insoles/ folder used by other catalogs. */
export const CUSTOM_MADE_IMAGE_BASE = '/photos/products';
